import { InView } from "react-intersection-observer";
const InViewComponent = ({reffing, active, isSpecial = false}) => {
    if(isSpecial){
        return (
        <InView className='w-full' as="div" onChange={(inView, entry) => {if(inView)isSpecial()}}>
        </InView>
        )
    }
    return (
    <InView className='w-full' as="div" onChange={(inView, entry) => {if(inView)reffing.current.classList.add(active)}}>
    </InView>
    )
}

export default InViewComponent;